var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRightArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  stroke: "currentColor",
  fill: "currentColor",
  strokeWidth: 0,
  viewBox: "0 0 1024 1024",
  height: "1em",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M765.7 486.8 314.9 134.7A7.97 7.97 0 0 0 302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 0 0 0-50.4z",
  stroke: "none"
})));
export { SvgRightArrow as ReactComponent };
export default __webpack_public_path__ + "static/media/svg/right-arrow.svg";